import { cva } from 'class-variance-authority';

export const content = cva(['flex', 'flex-col', 'gap-4', 'h-full']);

export const tabs = cva(['h-full', 'flex', 'flex-col', 'justify-normal']);

export const tabsList = cva(['grid', 'grid-cols-2', 'h-30']);
